import React from "react";

export default function Contact() {
  return (
    <section className="section">
      <h2>Contact</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et.
        Cras mattis consectetur purus sit amet fermentum. Aenean lacinia bibendum nulla sed consectetur.
      </p>
      <p>
        Email: lorem.ipsum@example.com
      </p>
    </section>
  );
}


